/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { combineReducers } from 'redux';

import * as recipientActions from './Recipient-Actions';
import * as recipientOperations from './Recipient-Operations';
import * as recipientReducer from './Recipient-Reducer';

// Ducks
import recipientFormReducer, { recipientFormOperations, recipientFormActions } from './ducks/RecipientForm';
import retryCalculateShippingReducer, { retryCalculateShippingActions } from './ducks/RetryCalculateShipping';
import shippingInfoReducer, { shippingInfoActions, shippingInfoOperations } from './ducks/ShippingInfo';
import giftMessageReducer, { giftMessageFormActions, giftMessageFormOperations, giftMessageFormSelectors } from './ducks/GiftMessageForm';
import cardIsleReducer, { cardIsleActions, cardIsleOperations, cardIsleHelpers } from './ducks/CardIsle';
import giftMessageExpressionsReducer, {
    giftMessageExpressionsActions,
    // giftMessageExpressionsOperations
} from './ducks/GiftMessageExpressions';

const recipientReducers = combineReducers({
    recipients: recipientReducer.recipientsReducer,
    orderItems: recipientReducer.orderItemsReducer,
    workingRecipient: recipientReducer.workingRecipientReducer,
    recipientForm: recipientFormReducer,
    calShipping: retryCalculateShippingReducer,
    shippingInfo: shippingInfoReducer,
    giftMessageExpressions: giftMessageExpressionsReducer,
    giftMessage: giftMessageReducer,
    cardIsle: cardIsleReducer,
});

const recipientDucks = {
    recipientForm: {
        recipientFormOperations,
        recipientFormActions,
    },
    giftMessageForm: {
        giftMessageFormActions,
        giftMessageFormOperations,
        giftMessageFormSelectors,
        giftMessageReducer,
    },
    retryCalculateShipping: {
        retryCalculateShippingActions,
        retryCalculateShippingReducer,
    },
    shippingInfo: {
        shippingInfoActions,
        shippingInfoOperations,
        shippingInfoReducer,
    },
    giftMessageExpressions: {
        giftMessageExpressionsActions,
        // giftMessageExpressionsOperations,
    },
    cardIsle: {
        cardIsleActions,
        cardIsleOperations,
        cardIsleReducer,
        cardIsleHelpers,
    },
};

const recipientWatcherSagas = [
    ...recipientFormOperations.watchers,
    ...giftMessageFormOperations.watchers,
    ...recipientOperations.watchers,
    ...shippingInfoOperations.watchers,
    ...cardIsleOperations.watchers,
    // ...giftMessageExpressionsOperations.watchers,
];

export {
    recipientOperations,
    recipientActions,
    recipientWatcherSagas,
    recipientDucks,
};

export default recipientReducers;
